import { useCallback, useEffect } from 'react';
import ApplicationService from 'src/services/ApplicationService';
import useTranslation from 'next-translate/useTranslation';
import { CustomMessage } from 'src/interfaces/PlayerError';
import { PLATFORM, URL_HELP_CENTER, COMMON_ERRORS } from './constants';

const useCustomMesageError = () => {
  const { t } = useTranslation('common');

  const setCustomMessageError = useCallback(() => {
    const errorsMessage: CustomMessage = {} as CustomMessage;

    COMMON_ERRORS.forEach((item) => {
      errorsMessage[item.code] = {
        code: item.custom_code,
        platform: PLATFORM,
        headline: t(`player_error.${item.category}.headline`),
        message: t(`player_error.${item.category}.message`, {
          link_help_center_element: `<a href="${URL_HELP_CENTER}" target="_balnk">${t('help_center')}</a>`,
          interpolation: { escapeValue: false },
        }),
      };
    });

    ApplicationService.player?.setCustomErrorMessages(errorsMessage);
  }, [t]);

  useEffect(() => {
    setCustomMessageError();
  }, [setCustomMessageError]);
};

export default useCustomMesageError;
